import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Slider from "react-slick"

import "./section-competition.scss"
import CompetitionElement from "../competition-element/competition-element"

const SectionCompetition = ({ contentInfo, classNameCategory }) => {


  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-competition-next" onClick={onClick} />
  }
  const PrevArrow = props => {
    const { onClick } = props
    return <span className="f-slider-home-competition-prev" onClick={onClick} />
  }
  var settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,

    variableWidth: contentInfo.length === 1 ? false : true,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  if (contentInfo.length === 0) {
    return null
  } else {
    return (
      <section
        className={
          "f-section-competition-container f-section-competition-container-" +
          classNameCategory
        }
      >
        <div className="f-competition-title-container">
          <TitleTab className="f-TitleTab f-TitleTab-pink" title="Concursos" />
        </div>

        <Slider {...settings} className="f-carousel-competition">
          {contentInfo.map((info, index) => {
              if (!info.ocultarDestacadoHome) {
                return (
                  <CompetitionElement
                    redireccionParaParticipar={info.redireccionParaParticipar}
                    slug={info.slug}
                    key={index}
                    urlImg={info.imagenHome ? info.imagenHome.file.url : null}
                    altImg={info.imagenHome && info.imagenHome.description}
                    typeButton={info.estadoConcurso}
                  />
                )
              }

            },
          )}
        </Slider>
      </section>
    )
  }
}

export default SectionCompetition
